/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { user } from '../models/common/user';
import { IceTypes } from '../models/icetypes';
import { Iceutility } from '../services/iceutility';
import { LoginConfig } from './login.config';
import { LoginService } from './login.service';

declare var require: any;

@Injectable()
export class SignerService extends LoginService {

  constructor(private http1: HttpClient,
    private router: Router) {
    super(http1);
  }

  public DoGrantAuth(cltId, cltSecret, authCode, redirectUrl?: string): Observable<any> {
    if (cltId == null || cltId.length == 0
      || authCode == null || authCode.length == 0
      || cltSecret == null || cltSecret.length == 0) {
      if (cltSecret == null || cltSecret.length == 0) {
        cltSecret = this.client_s;
      }
      else {
        console.log("Invalid parameters in DoGrantAuth.");
        return Observable.throw({ errorCode: 0, errorMessage: "Invalid parameters in DoGrantAuth." });
      }
    }

    var tokenreqdata = 'client_id' + "=" + cltId
      + '&redirect_uri=' + encodeURIComponent(this.identity_signerRedirectUrl) + '&grant_type=authorization_code' + '&code=' + authCode;

    var auth = 'Basic ' + super.getBase64().encode(cltId + ":" + cltSecret);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
        'Authorization': auth
      })
    };

    return this.http1.post(
      this.identity_tokenUri,
      tokenreqdata,
      httpOptions
    )
      .pipe(
        tap(
          response => this.DoLoginComplete(response, redirectUrl),
          error => {
            if (error != null) {
              console.log(JSON.stringify(error));
            }
          })
      );
  }

  public GetLoginUrl(responsetype: string, state?: string) {
    if (responsetype == null || responsetype.length == 0) responsetype = 'code';
    if (state == null)
      state = 'Signer;';

    let uri = super.AddQueryString(this.identity_authorizeUri, {
      'client_id': this.client_id,
      'redirect_uri': this.identity_signerRedirectUrl,
      'state': state,
      'scope': this.identity_token_scope,
      'response_type': responsetype,
    }); return uri;
  }

  public DoLoginComplete(response: any, redirectUrl?: string) {
    if (response == null) {
      console.log("No data is login response.");
      return;
    }

    var tokenobject = null;
    if (super.isdefined(response["data"]))
      tokenobject = response.data;
    else
      tokenobject = response;

    if (tokenobject == null) {
      console.log("Invalid token structure.");
      console.log("Login completed but failed to process!");
      return;
    }

    let token = "", issued = "", expires = "";

    let usr = new user();
    usr.login_user_name = tokenobject["UserName"];
    usr.nameofnetwork = tokenobject["Name"];
    usr.email = tokenobject["EMAIL"];
    let data = {
        token: tokenobject["access_token"],
        issued: tokenobject[".issued"],
        expires: tokenobject[".expires"]
      };
    try {
      usr["data"] = data;
    }
    catch (e) {
      console.log(e);
    }

    let state = "";
    let signerParams = super.ParseParams(window.location.href);
    if (signerParams != null) {
      state = signerParams["state"];
    }

    if (state != null && state.length > 0) {
      let parts = state.split(";");
      let act: string = "";
      let acttype: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
      let srckey: string = "";
      let srctype: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
      let apiToUse = "";

      for (let ip = 0; ip < parts.length; ip++) {
        let param = parts[ip];
        let paramParts = param.split(":");
        if (paramParts.length == 2) {
          switch (paramParts[0]) {
            case "act": {
              act = paramParts[1];
              break;
            }
            case "acttype": {
              acttype = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(paramParts[1]);
              switch (acttype) {
                case IceTypes.ACCOUNT_TYPE.actFacility:
                case IceTypes.ACCOUNT_TYPE.actProvider: {
                  apiToUse = "providers";
                  break;
                }
                case IceTypes.ACCOUNT_TYPE.actPharmacy: {
                  apiToUse = "pharmacies";
                  break;
                }
                case IceTypes.ACCOUNT_TYPE.actPayer: {
                  apiToUse = "payers";
                  break;
                }
                case IceTypes.ACCOUNT_TYPE.actVendor: {
                  apiToUse = "vendors";
                  break;
                }
              }
              break;
            }
            case "srckey": {
                srckey = paramParts[1];
                break;
            }
            case "srctype": {
                srctype = <IceTypes.SourceType>Iceutility.toLong(paramParts[1]);
                break;
            }
            case "title": {
              usr.suffix = decodeURIComponent(paramParts[1]);
              break;
            }
            case "signaturedata":
              let signData = sessionStorage.getItem(paramParts[1]);
              //usr.signature_code = this.getBase64().decode(paramParts[1]);
              usr.signature_code = this.getBase64().decode(signData);
              break;
            case "url": {
              redirectUrl = decodeURIComponent(LoginConfig.getFormattedPath(this.app_path, paramParts[1]));
              break;
            }
          }
        }
      }

      switch (srctype) {
        case IceTypes.SourceType.srcStatement: {
          this.signReport(apiToUse, act, acttype, srckey, usr).subscribe(
            data => {
              debugger;
            },
            error => {
            });
          break;
        }
      }
    }

    console.log("Signing completed successfully!");
    return this.PostLoginComplete(usr, redirectUrl);
  }

  public PostLoginComplete(userInfo: any, redirectUrl?: string): Observable<any> {
    if (userInfo == null || userInfo.UserId == 0) {
      return Observable.throw('Invalid user information.');
    }

    if (redirectUrl == null) redirectUrl = "";

    this.router.navigate([redirectUrl]);

    return Observable.of('Post Login Complete!');
  }

  public signReport(api: string, act: string, acttype: IceTypes.ACCOUNT_TYPE, key: string, usr: user): Observable<any> {
    let currentEnv: any = require("../../../../env.json").currentEnv;
    let envs: any = require("../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Report service is not configured.";
    if (usr == null) throw "Report object invalid.";
    if (act == null || act.length == 0) throw "Account input invalid.";
    if (api == null || api.length == 0) throw "API input invalid.";

    let url = envs[currentEnv].icemedx_api + "/" + api + "/default.aspx?domain=" + act + "&data=signreport&domaintype=" + acttype.toString() + "&key=" + key + "&subkeys=";

    let tblname = usr.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(usr) + "}";
    return this.http1.post(url, data, { responseType: 'text' });
  }
}
